import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchBtvChannelCategories } from '@/store/slices/btv-channel-categories';
import {
  selectBtvChannelCategories,
  selectIsLoadingBtvChannelCategories,
} from '@/store/slices/btv-channel-categories/selectors';
import { getActiveChannel, getChannelType } from '@/store/slices/user/selectors';
import { ChannelType } from '@/types/channel.types';

const useLoadBtvChannelCategories = () => {
  const dispatch = useAppDispatch();
  const channelType = useAppSelector(getChannelType);
  const activeChannel = useAppSelector(getActiveChannel);
  const categories = useAppSelector(selectBtvChannelCategories);
  const loading = useAppSelector(selectIsLoadingBtvChannelCategories);

  const fetchedChannel = useRef<number | null>(null);

  useEffect(() => {
    if (channelType !== ChannelType.BrandTV) {
      fetchedChannel.current = null;
      return;
    }
    if (fetchedChannel.current === activeChannel) return;
    fetchedChannel.current = activeChannel;
    dispatch(fetchBtvChannelCategories());
  }, [activeChannel, channelType, dispatch]);

  return { categories, loading };
};

export default useLoadBtvChannelCategories;
